import React, { useState, useRef, useEffect, useContext } from 'react';
import { IntersectionObserverContext, LazyLoadContext } from '@riac/core';

export const ImgLazyLoader = (props: React.PropsWithChildren): JSX.Element => {
  const [loaded, setLoaded] = useState(false);
  const placeholderRef = useRef(null);
  const observer = useContext(IntersectionObserverContext);
  const { forceLoad } = useContext(LazyLoadContext);

  useEffect(()=>{
    if(observer.supported)
    {
      observer.subscribe(placeholderRef, () => {
        observer.unsubscribe(placeholderRef);
        setLoaded(true);
      });
    }
    else
    {
      const checkImagePosition = () => {
        const top = window.pageYOffset;
        const target = (window.innerHeight + 100) + top;

        if(placeholderRef.current.offsetTop < target)
        {
          setLoaded(true);
          document.removeEventListener('scroll', checkImagePosition);
          window.removeEventListener('resize', checkImagePosition);
          window.removeEventListener('orientationchange', checkImagePosition);
        }
      };

      document.addEventListener('scroll', checkImagePosition);
      window.addEventListener('resize', checkImagePosition);
      window.addEventListener('orientationchange', checkImagePosition);

      checkImagePosition();
    }

    return () => {
      if(loaded == false)
      {
        observer.unsubscribe(placeholderRef);
      }
    };
  }, []);

  useEffect(() => {
    if(forceLoad === true && loaded === false)
    {
      setLoaded(true);

      if(observer.supported) {
        observer.unsubscribe(placeholderRef);
      }
    }
  }, [forceLoad]);

  return loaded ? props.children : <>
    <span ref = {placeholderRef}>
      <noscript>{props.children}</noscript>
    </span>
  </>;
};
